let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("29Sce")).then(() => parcelRequire('lQyzT'));